// extracted by mini-css-extract-plugin
export default {"skeleton":"azYijQdw5TPTlFAMrHA7","skeletonKeyframes":"T0CbCd5f5RwcIrLyK4s4"};